/* List of Playwright data_testid attributes strings */

import type { SearchResultType } from '@framework/constants/enums/globalSearch';

// navigations
export const APP_HEADER = 'app-header';
export const APP_HEADER_ROOMS_TITLE = 'rooms-title';
export const APP_HEADER_AVATAR = 'avatar-icon';
export const APP_SIDE_MENU = 'app-side-menu';
export const BACK_BUTTON = 'back-button';
export const BULK_ACTIONS_CONTAINER = 'bulk-actions-container';
export const BULK_ACTIONS_BAR = 'bulk-actions-bar';
export const ADMIN_PORTAL_TILE = 'admin-portal-tile';
export const COMMENT_BOX = 'comment-box';
export const PROGRESS_BAR = 'progress-bar';
export const NOTIFICATIONS = 'notifications';
export const DOT_NEUTRAL = 'dot-icon-neutral';
export const ICON_SUCCESS = 'icon-success';
export const ICON_ERROR = 'icon-error';
export const EDIT_MODE_SWITCH = 'switch-to-edit-mode';
export const VIEW_MODE_SWITCH = 'switch-to-view-mode';
export const COLLAPSE_ICON = 'collapse-icon';
export const COLLAPSE_BAR = 'collapse-bar';
export const ROOM_SELECT_TRIGGER = 'room-select-trigger';
export const USER_MENU_LIST = 'user-menu-list';
export const USER_MENU_AVATAR = 'user-menu-avatar';
export const ROOM_SELECT_LIST = 'room-select-list';
export const ROOM_SELECT_LIST_ITEM = 'room-select-list-item';
export const ROOM_SELECT_ACTIVE_ITEM = 'room-select-active-item';
export const GIVE_ACCESS_LOADING = 'give-access-loading';
export const LIBRARY_CORPORATE_SEGMENTED_TAB_BUTTON = 'corporate-segmented-tab-button';
export const LIBRARY_PRIVATE_SEGMENTED_TAB_BUTTON = 'private-segmented-tab-button';
export const USER_MANAGEMENT_MEMBERS_SEGMENTED_TAB_BUTTON = 'members-segmented-tab-button';
export const USER_MANAGEMENT_GROUPS_SEGMENTED_TAB_BUTTON = 'groups-segmented-tab-button';
export const TASKS_DECISIONS_TASKS_SEGMENTED_TAB_BUTTON = 'tasks-segmented-tab-button';
export const TASKS_DECISIONS_DECISIONS_SEGMENTED_TAB_BUTTON = 'decisions-segmented-tab-button';

// support
export const GIVE_ACCESS_CSM_SELECT = 'csm-select';
export const GIVE_ACCESS_TIME_SELECT = 'time-select';

// settings
export const SETTINGS_ITEM = 'settings-item';
export const SETTINGS_PROFILE_SAVE = 'save-user-profile';
export const SETTINGS_PROFILE_CLOSE = 'close-user-profile';
export const SETTINGS_PROFILE_EDIT = 'edit-user-profile';
export const SETTINGS_AMBASSADOR_SWITCH = 'switch-user-settings';

// details
export const GENERAL_DETAILS_PANEL = 'details-panel';
export const GENERAL_MODAL_DELETE_CONFIRM = 'confirm-delete-modal';
export const CONFIRM_DELETE_BUTTON = 'confirm-delete-button';
export const CUSTOM_INVITATION = 'custom-invitation';
export const MEMBERS_DETAILS_PANEL = 'member-details-panel';
export const MEMBERS_DETAILS_SAVE = 'member-details-save';
export const MEMBERS_DETAILS_EDIT = 'member-details-edit';
export const MEMBERS_DETAILS_DELETE = 'member-details-delete';
export const MEMBERS_DETAILS_MEMBER_NAME = 'member-details-member-name';
export const MEMBERS_FORM_PANEL = 'member-form-panel';
export const MEMBERS_ADD_MEMBER_SIDE_PANEL_PORTAL = 'add-member-side-panel-portal';
export const MEMBERS_FORM_GROUPS_PICKER = 'member-form-groups-picker';
export const MEMBERS_FILTERS = 'members-filters';
export const MEMBER_FORM_PERMISSIONS_STEP = 'member-form-permissions-step';
export const TIMEZONE_LIST = 'timezone-list';
export const TIMEZONE_INFO = 'timezone-info';
export const ADD_PEOPLE_INPUT = 'add-people-input-field';
export const MEETING_ACTIONS_CONTAINER = 'meeting-actions-container';
export const MORE_ACTIONS_MENU = 'more-actions-menu';
export const MORE_ACTIONS_MENU_MEETING_HISTORY = 'more-actions-menu-history';
export const MORE_ACTIONS_MENU_DELETE = 'more-actions-menu-delete';
export const MORE_ACTIONS_MENU_CREATE_TEMPLATE = 'more-actions-menu-create-template';
export const MORE_ACTIONS_MENU_DOCUMENT_SECURITY_SETTINGS =
    'more-actions-menu-document-security-settings';
export const MORE_ACTIONS_MENU_LOCK_UNLOCK_MEETING = 'more-actions-menu-lock-unlock-meeting';
export const MEMBERS_ROW = 'group-members-row';
export const GROUP_MANAGERS_LIST = 'group-managers-list';
export const GROUP_MANAGERS_SELECT = 'group-managers-select';
export const ADD_MEMBERS_TO_GROUP_SEARCH = 'add-members-to-group-search';
export const ADD_MEMBERS_ROW = 'add-member-row';
export const ADD_MEMBERS_TO_GROUP_BUTTON = 'add-members-to-group-button';
export const START_TIME_PICKER = 'start-time';
export const END_TIME_PICKER = 'end-time';
export const DATE_PICKER = 'date-picker';
export const MEETING_LEADER_SECTION = 'meeting-leader-section';
export const MEETING_LEADER_ACTION_MENU_BUTTON = 'meeting-leader-action-button';
export const MEETING_LEADER_SELECTOR = 'meeting-leader-selector';
export const OPEN_MEETING_LEADER_MODAL_BUTTON = 'open-meeting-leader-modal-button';
export const MEETING_PARTICIPANT_ACTION_MENU_BUTTON = 'meeting-participant-action-menu-button';
export const MEETING_PARTICIPANT_ACTION_MENU = 'meeting-participant-action-menu';
export const AGENDA_ACCESS_ICON = 'agenda-access-icon';
export const GUEST_ACCESS_ICON = 'guest-access-icon';
export const AGENDA_ACCESS_WARNING = 'agenda-access-warning';
export const MANAGE_AGENDA_ACCESS_BUTTON_ON_DETAILS = 'manage-agenda-access-button';
export const AGENDA_ACCESS_LIST = 'agenda-access-list';
export const OPEN_INVITE_GUEST_MODAL_VIA_MENU_BUTTON = 'open-invite-guest-modal-via-menu-button';
export const OPEN_INVITE_GUEST_MODAL_VIA_SEARCH = 'open-invite-guest-modal-via-search';
export const OPEN_INVITE_MINUTES_VIEWER_MODAL_VIA_MENU_BUTTON =
    'open-invite-minutes-viewer-modal-via-menu-button';
export const OPEN_INVITE_MINUTES_VIEWER_MODAL_VIA_SEARCH =
    'open-invite-minutes-viewer-modal-via-search';
export const ADD_EXISTING_PERSON_AS_GUEST = 'add-existing-person-as-guest';
export const GO_TO_THIS_PERSON = 'go-to-this-person';
export const CLONE_MEETING_BUTTON = 'clone-meeting-button';
export const ASSISTANTS_SECTION = 'assistants-section';
export const ASSISTANTS_LIST = 'assistants-list';
export const ASSISTANT_PICKER = 'assistant-picker';
export const ASSISTANT_PICKER_DROPDOWN_MENU = 'assistant-picker-dropdown-menu';
export const ASSISTANT_LIST_ROW = (name: string) => `assistant-list-row: ${name}`;
export const ASSISTANT_REMOVE_BUTTON = 'remove-assistant-button';
export const ASSISTANT_PREVIEW_BUTTON = 'preview-assistant-button';
export const MEETING_DETAILS_TOP_BAR = 'meeting-details-top-bar';
export const OPEN_SEND_EMAIL_MODAL = 'open-send-email-modal';
export const SEND_EMAIL_MODAL_SELECT_ALL_MINUTES_VIEWERS =
    'send-email-modal-select-all-minutes-viewers';
export const INVITATION_FILE_UPLOADER = 'invitation-file-uploader';
export const CUSTOM_INVITATION_PREVIEW = 'custom-invitation-preview';
export const CUSTOM_INVITATION_ACTIONS = 'custom-invitation-actions';
export const CREATE_MEETING_BUTTON = 'create-meeting-button';
export const UPDATE_MEETING_BUTTON = 'update-meeting-button';
export const CANCEL_MEETING_BUTTON = 'cancel-meeting-button';
export const INVITATION_UPLOAD_STATUS_BAR = 'invitation-upload-status-bar';
export const INVITATION_ACTIONS = 'invitation-actions';
export const SHARE_MEETING_ACTION_BUTTON = 'share-meeting-action-button';
export const NOTIFY_MEETING_ACTION_BUTTON = 'notify-meeting-action-button';
export const CLONE_MEETING_ACTION_BUTTON = 'clone-meeting-action-button';

// meeting view mode
export const JOIN_CALL_OVERVIEW_BUTTON = 'join-call-overview-button';
export const POINTER_SPOTLIGHT = 'pointer-spotlight';
export const MEETING_DATE_TIME = 'meeting-date-time';
export const MEETING_DATE_LABEL = 'meeting-date-label';
export const MEETING_DATE_INFO = 'meeting-date-info';
export const PARTIAL_MEETING_DATE_TIME = 'partial-meeting-date-time';
export const MEETING_VIEW_AGENDA_ITEM_CARD = 'meeting-view-agenda-item-card';

// meeting preparedness
export const PERSONAL_MEETING_PREPAREDNESS_LEVEL = 'personal-meeting-preparedness-level';
export const OVERALL_MEETING_PREPAREDNESS_LEVEL = 'overall-meeting-preparedness-level';
export const OPEN_MEETING_PREPAREDNESS_SETTINGS_MODAL = 'open-meeting-preparedness-settings-modal';
export const SHOW_COMPLETED_TOGGLE = 'show-completed-toggle';
export const SEND_REMINDER_EDITOR = 'send-reminder-editor';
export const NOTHING_TO_PREPARE = 'nothing-to-prepare';
export const COMPLETED_PREPARATION = 'completed-preparation';

// meeting history
export const LIST_ELEMENT_HISTORY_ROW = 'list-element-history-row';
export const LIST_ELEMENT_HISTORY_DATE = 'list-element-history-date';
export const LIST_ELEMENT_HISTORY_USER = 'list-element-history-user';
export const LIST_ELEMENT_HISTORY_TITLE = 'list-element-history-title';
export const LIST_ELEMENT_HISTORY_TYPE = 'list-element-history-type';
export const LIST_ELEMENT_HISTORY_DESCRIPTION = 'list-element-history-description';
export const TOGGLE_EXPAND_BUTTON = 'toggle-expand-button';

// minutes editor
export const MINUTES_EDITOR_STATUS = 'minutes-editor-status';
export const MINUTES_EDITOR_ADD_TEXT_BLOCK = 'add-text-block';
export const MINUTES_EDITOR_LAYOUT = 'minutes-editor-layout';
export const MINUTES_EDITOR_CONTAINER = 'minutes-editor-container';
export const MINUTES_EDITOR_TOP_BAR = 'minutes-editor-top-bar';
export const MINUTES_EDITOR_SAVED_STATUS = 'minutes-editor-saved-status';
export const MINUTES_EDITOR_PAGE = 'minutes-editor-page';
export const MINUTES_EDITOR_AGENDA_ITEM = 'minutes-editor-agenda-item';
export const MINUTES_EDITOR_DOCUMENT_ITEM = 'minutes-editor-document-item';
export const MINUTES_EDITOR_PAGE_MAIN_CONTENT = 'minutes-editor-page-main-content';
export const MINUTES_EDITOR_TASKS_ITEM = 'minutes-editor-tasks-item';
export const MINUTES_EDITOR_DECISIONS_ITEM = 'minutes-editor-decisions-item';

// agenda
export const TYPE_NEW_AGENDA_ITEM = 'type-new-agenda-item';
export const SAVE_AGENDA_ITEM = 'save-agenda-item';
export const CANCEL_AGENDA_ITEM = 'cancel-agenda-item';
export const ACCESS_GROUPS_SECTION_HEADER = 'access-groups-section-header';
export const ACCESS_GUESTS_SECTION_HEADER = 'access-guests-section-header';
export const ACCESS_NONPARTICIPANTS_SECTION_HEADER = 'access-nonparticipants-section-header';
export const ACCESS_PARTICIPANTS_SECTION_HEADER = 'access-participants-section-header';
export const AGENDA_CONTRIBUTOR_ROW = 'agenda-contributor-row';
export const AGENDA_CONTRIBUTION_ACTIONS_MENU = 'agenda-contribution-actions-menu';
export const AGENDA_EXCLUSION_ICON = 'manage-access-with-exclusion-icon';
export const AGENDA_MANAGE_ACCESS = 'manage-access';
export const AGENDA_ITEM_TYPE = 'agenda-item-type';
export const AGENDA_TYPE = 'agenda-type';
export const AGENDA_ITEM_EXPAND_COLLAPSE = 'agenda-item-expand-collapse';
export const AGENDA_ITEM_ROW = 'agenda-item-row';
export const AGENDA_ITEM_NUMBER = 'agenda-item-number';
export const AGENDA_DOCUMENT_MORE_MENU = 'document-more-menu';
export const AGENDA_EXTERNAL_CONTENT_MORE_MENU = 'external-content-more-menu';
export const ISOM_AGENDA_STATUS = 'isom-agenda-status';
export const AGENDA_ITEM_TITLE = 'agenda-item-title';
export const AGENDA_ITEM_DESCRIPTION = 'contenteditable-remarks';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL = 'agenda-item-classification-level';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL_INTERNAL = 'internal';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL_CONFIDENTIAL = 'confidential';
export const AGENDA_ITEM_CLASSIFICATION_LEVEL_SECRET = 'secret';
export const AGENDA_ITEM_GUESTS = 'agenda-item-guests';
export const AGENDA_ITEM_NAME = 'agenda-item-name';
export const AGENDA_ITEM_NAME_INPUT = 'agenda-item-name-input';
export const AGENDA_DURATION_TIME = 'agenda-item-duration';
export const AGENDA_UNPUBLISHED = 'unpublished-change';
export const CANCEL_VOTE = 'cancel-vote';
export const CHANGE_VOTE = 'change-vote';
export const EDIT_DOCUMENT_BUTTON = 'edit-document-button';
export const SAVE_VOTE = 'save-vote';
export const NEXT_BUTTON_VOTE_SET_UP_MODAL = 'next-button-vote-set-up-modal';
export const SAVE_SET_UP_VOTE = 'save-set-up-vote';
export const VOTE = 'vote';
export const VOTE_ABSTAIN = 'vote-abstain';
export const VOTE_CONTAINER = 'vote-container';
export const VOTE_NO = 'vote-no';
export const VOTE_REQUEST_DISCUSSION = 'vote-request-discussion';
export const VOTE_YES = 'vote-yes';
export const VOTING_AGENDA_ITEM_TITLE = 'voting-agenda-item-title';
export const SET_UP_A_VOTE_MODAL = 'setup-a-vote-modal';
export const VOTING_YES_ICON = 'voting-yes-icon';
export const VOTING_NO_ICON = 'voting-no-icon';
export const VOTING_ABSTAIN_ICON = 'voting-abstain-icon';
export const VOTING_DISCUSSION_ICON = 'voting-discussion-icon';
export const VOTING_PENDING_ICON = 'voting-pending-icon';
export const EXTERNAL_LINK_ICON = 'external-link-icon';
export const ISOM_SHARE_DRAFT_INPUT = 'share-draft-search-input';
export const ATTACHABLE_CHECKBOX = 'attachable-checkbox';
export const AGENDA_PDF_DOWNLOAD = 'agendaPDF-download-button';
export const MEETING_BOOK_PDF_DOWNLOAD = 'meetingBookPDF-download-button';
export const AGENDA_MORE_ACTIONS_MENU = 'agenda-more-actions-menu';
export const AGENDA_MORE_ACTIONS_MENU_BUTTON = 'agenda-more-actions-menu-button';
export const OPEN_ADD_GUESTS_MODAL = 'open-add-guests-modal';
export const ADD_GUESTS_SELECTOR = 'add-guests-selector';
export const ADD_GUESTS_SAVE_BUTTON = 'add-guests-save-button';
export const ADD_GUESTS_CANCEL_BUTTON = 'add-guests-cancel-button';
export const GUEST_AGENDA_ACCESS_CHECKBOX = 'guest-agenda-access-checkbox';
export const ADDED_GUEST_ROW = 'added-guest-row';
export const HIGHLIGHTED_ADDED_GUEST_ROW = 'highlighted-added-guest-row';
export const BULK_SELECT_ALL_CHECKBOX = 'bulk-select-all-checkbox';
export const BULK_ADD_GUEST_BUTTON = 'bulk-add-guest-button';
export const BULK_DOWNLOAD_DOCUMENTS_BUTTON = 'bulk-download-documents-button';
export const ACCESS_MANAGEMENT_USER_ROW = 'access-management-user-row';
export const ACCESS_MANAGEMENT_CHECKBOX = 'access-management-checkbox';
export const ADD_GUEST_DROPDOWN_OPTION = 'add-guest-dropdown-option';
export const EXISTING_VOTE_CONFIRMATION_CHECKBOX = 'existing-vote-confirmation-checkbox';
export const ACCESS_MANAGEMENT_USER_CLASSIFICATION_LEVEL =
    'access-management-user-classification-level';
export const AGENDA_NUMBER_INPUT = 'agenda-number-input';
export const SEND_NOTIFICATION_CHECKBOX = 'send-notification-checkbox';
export const INCLUDE_CALENDAR_INVITATION = 'include-calendar-invitation';
export const NOTIFICATION_INPUT = 'notification-input';
export const SECURITY_LEVEL = 'security-level';
export const EXTERNAL_CONTENT_POPOVER = 'external-content-popover';
export const RENAME_DOCUMENT_BUTTON = 'rename-document-button';
export const SAVE_DOCUMENT_NAME_BUTTON = 'save-document-name-button';
export const AGENDA_ITEM_SECURITY_LEVEL = 'agenda-item-security-level';
export const AGENDA_DOCUMENT_PRE_READING_BUTTON = 'agenda-document-pre-reading-button';
export const AGENDA_COMMENT_COUNT = 'agenda-comment-count';
export const DOWNLOAD_PDF_BUTTON = 'download-pdf-button';
export const DOWNLOAD_ORIGINAL_BUTTON = 'download-original-button';
export const AGENDA_ITEM_CONTENT_SKELETON = 'agenda-item-content-skeleton';
export const CONTRIBUTION_REQUEST_USER_SELECTOR = 'contribution-request-user-selector';
export const CONTRIBUTION_REQUEST_MESSAGE_INPUT = 'contribution-request-message-input';
export const AGENDA_DOCUMENT_COUNT = 'agenda-document-count';
export const AGENDA_PUBLISH_BUTTON = 'agenda-publish-button';
export const AGENDA_COMMENT_MORE_ACTIONS_MENU = 'agenda-comment-more-actions-menu';
export const COMMENTS_PANEL = 'comments-panel';

export const AGENDA_ITEM_CONTENT = 'agenda-item-content';
export const OPEN_IN_NEW_TAB_LINK = 'open-in-new-tab-link';
export const LINK_PREVIEW_IFRAME = 'link-preview-iframe';
// comments
export const MENTION_USERNAME = 'mention-username';
export const COMMENT_THREAD = 'comment-thread';

// minutes
export const HEADING_ONE_FORMATTING = 'heading-one';
export const HEADING_TWO_FORMATTING = 'heading-two';
export const HIGHLIGHT = 'highlight';
export const UNDERLINE = 'underline';
export const ALIGN_DROPDOWN = 'align-dropdown';
export const ALIGN_LEFT = 'align-left';
export const ALIGN_CENTER = 'align-center';
export const ALIGN_RIGHT = 'align-right';
export const MORE_ACTIONS = 'more-actions';
export const BOLD = 'bold';
export const ITALIC = 'italic';
export const UNDO = 'undo';
export const REDO = 'redo';
export const ORDERED_LIST = 'ordered-list';
export const UNORDERED_LIST = 'unordered-list';
export const SECTION_BREAK = 'section-break';
export const INSERT_AGENDA_ITEM_DESCRIPTION = 'insert-agenda-item-description';
export const IMAGE = 'image';

export const MINUTES_EDITOR = 'minutes-editor';
export const MINUTES_ROW = 'minutes-row';
export const MINUTES_ACTIONS_MENU = 'minutes-actions-menu';
export const PDF_LAYOUT_BUTTON = 'pdf-layout-button';
export const TASK_DECISION_ROW = 'taskdecision-row';
export const TASK_DECISION_STATUS = 'taskdecision-status';
export const TASK_FORM_NAME = 'task-form-name';
export const TASK_FORM_DESCRIPTION = 'task-form-description';
export const TASK_FORM_ASSIGNEE = 'task-form-assignee';
export const TASK_FORM_DATE = 'task-form-date';
export const TASK_FORM_SAVE = 'task-form-save';
export const TASK_NAME = 'task-name';
export const TASK_DESCRIPTION = 'task-description';
export const TASK_ASSIGNEE = 'task-assignee';
export const TASK_DATE = 'task-date';
export const TASK_STATUS = 'task-status';
export const CHANGE_STATUS_DROPDOWN = 'change-status-dropdown';
export const DECISION_FORM_DESCRIPTION = 'decision-form-description';
export const DECISION_FORM_ASSIGNEE = 'decision-form-assignee';
export const DECISION_FORM_DATE = 'decision-form-date';
export const DECISION_FORM_SAVE = 'decision-form-save';
export const DECISION_DESCRIPTION = 'decision-description';
export const DECISION_ASSIGNEE = 'decision-assignee';
export const DECISION_DATE = 'decision-date';
export const DECISION_STATUS = 'decision-status';
export const MINUTES_EDITOR_UPLOAD_IMAGE_INPUT = 'minutes-editor-upload-image-input';
export const MINUTES_EDITOR_IMAGE_CONTAINER = 'minutes-editor-image-container';
export const MINUTES_EDITOR_REMOVE_IMAGE = 'minutes-editor-remove-image';
export const MINUTES_EDITOR_RESIZE_IMAGE = 'minutes-editor-resize-image';
export const MINUTES_EDITOR_INCREASE_INDENTATION = 'minutes-editor-increase-indentation';
export const MINUTES_EDITOR_DECREASE_INDENTATION = 'minutes-editor-decrease-indentation';
export const MINUTES_ATTENDANCE_EXPAND = 'minute-attendance-expand';
export const MINUTES_ATTENDANCE_MEETING_LEADER_LABEL = 'minutes-attendance-meeting-leader-label';
export const MINUTES_ATTENDANCE_GUEST_LABEL = 'minutes-attendance-guest-label';
export const MINUTES_ATTENDANCE_EDIT_MEETING_ROLE = 'minutes-attendance-edit-meeting-role';
export const MINUTES_ATTENDANCE_MEETING_ROLE_INPUT = 'minutes-attendance-meeting-role-input';
export const MINUTES_ATTENDANCE_PARTICIPANT_ROW = 'minutes-attendance-participant-row';
export const MINUTES_MEETING_ROLE_SAVE_BUTTON = 'minutes-meeting-role-save-button';
export const MINUTES_MEETING_ROLE_CANCEL_BUTTON = 'minutes-meeting-role-cancel-button';
export const MINUTES_LAYOUT_CELL_EDITOR = 'minutes-layout-cell-editor';
export const MINUTES_LAYOUT_CELL_EDITOR_IS_SAVED = 'minutes-layout-cell-editor-is-saved';
export const MINUTES_PUBLISH_BUTTON = 'minutes-publish-button';
export const TASK_DECISION_DRAFT_STATUS_CHIP = 'task-decision-draft-status-chip';
export const TASK_DECISION_STATUS_CHIP = 'task-decision-status-chip';

export const MINUTES_VIEWERS_LIST_ROW = 'minutes-viewers-list-row';
export const MINUTES_AGENDA_ACCESS_BUTTON = 'minutes-agenda-access-button';
export const MINUTES_AGENDA_ACCESS_SEARCH = 'minutes-agenda-access-search';

export const MINUTES_SELECTOR_ROW = 'minutes-selector-row';

export const GENERATE_MINUTES_FILE = 'generate-minutes-file';

export const MINUTES_DOCUMENT_ROW = 'minutes-document-row';

export const PREPARING_DOCUMENT = 'preparing-document';

// minutes history
export const MINUTES_HISTORY_TIMELINE_TOP_LINE = 'minutes-history-timeline-top-line';
export const MINUTES_HISTORY_TIMELINE_BOTTOM_LINE = 'minutes-history-timeline-bottom-line';
export const MINUTES_HISTORY_TIMELINE_DOT = 'minutes-history-timeline-dot';
export const MINUTES_HISTORY_TIMELINE_ITEM_CARD = 'minutes-history-timeline-item-card';
export const MINUTES_HISTORY_LIST = 'minutes-history-list';
export const MINUTES_HISTORY_LIST_CLOSE = 'minutes-history-list-close';
export const MINUTES_HISTORY_DETAILS_VIEW = 'minutes-history-details-view';
export const MINUTES_HISTORY_SWITCH_DIFF_MODE = 'minutes-history-switch-diff-mode';
export const MINUTES_HISTORY_TOOLS = 'minutes-history-tools';

// meeting document download
export const DOWNLOAD_ALL_MEETING_DOCUMENTS = 'download-all-meeting-documents';
export const DOWNLOAD_ALL_MEETING_ORIGINAL_DOCUMENTS = 'download-all-meeting-original-documents';
export const DOWNLOAD_SECURED_DOCUMENTS = 'download-secured-documents';
export const DOWNLOAD_MINUTES_PDF = 'download-minutes-pdf';
export const DOWNLOAD_MINUTES_DOCX = 'download-minutes-docx';

// login
export const LOGOUT_ITEM = 'logout-item';
export const LOGIN_PASSWORD_RESET_EMAIL = 'password-reset-email';
export const PASSWORD_REQUIREMENT_ITEM = 'password-requirement-item';
export const LOGIN_USER_CHIP = 'login-user-chip';

// presenter mode
export const CANCEL_PRESENTING_CONFIRMATION = 'cancel-presenting-confirmation';
export const LEAVE_MEETING = 'leave-meeting';
export const PAUSE_PRESENTING = 'pause-presenting';
export const PRESENTATION_CONFIRMATION_FOOTER = 'presentation-confirmation-footer';
export const PRESENTER_WIDGET = 'presenter-widget';
export const START_PRESENTING = 'start-presenting';
export const START_PRESENTING_CONFIRMATION = 'start-presenting-confirmation';
export const STOP_PRESENTING = 'stop-presenting';
export const STOP_PRESENTING_CONFIRMATION = 'stop-presenting-confirmation';
export const MEETING_DETAIL_CONTAINER_RIGHT_PANEL = 'meeting-detail-container-right-panel';
export const ATTENDEE_WIDGET_BUTTON = 'attendee-widget-button';
export const ATTENDEES_LIST = 'attendees-list';
export const ATTENDEE_ROW = 'attendee-row';
export const ATTENDEE_NAME = 'attendee-name';
export const ATTENDEE_TITLE = 'attendee-title';
export const LEFT_PANEL = 'left-panel';

// tasks and decisions
export const PARTICIPANT_TAG_HELPER = 'participant-tag-helper';
export const TD_FILTER_GROUP = 'td-filter-group';
export const TD_FILTER_ASSIGNEE = 'td-filter-assignee';
export const TD_SIDE_PANEL = 'td-side-panel';
export const TD_FILTERS = 'td-filters';
export const TD_TASK_ACTIONS_TRIGGER = 'td-task-actions-trigger';
export const TD_REMARK_INPUT = 'remarks-input';
export const TD_STATUS_COLOR = 'td-status-color';
export const TD_TASK_ACTION_OPEN = 'td-task-action-open';
export const TD_TASK_ACTION_EDIT = 'td-task-action-edit';
export const TD_TASK_ACTION_REMOVE = 'td-task-action-remove';
export const TD_TASK_EDIT_STATUS_BUTTON = 'td-task-edit-status-button';
export const UNASSIGN_BUTTON = 'unassign-button';
export const TD_HISTORY_SEGMENT = 'td-history-segment';
export const TD_HISTORY_SEGMENT_LABEL = 'td-history-segment-label';
export const TD_HISTORY_SEGMENT_COMPONENT = 'td-history-segment-component';

// topic hub
export const TOPIC_ADD = 'add-new-topic';
export const TOPIC_HUB_SIDE_PANEL = 'side-panel';
export const TOPIC_HUB_FILTERS = 'topic-hub-filters';
export const TOPIC_HUB_CLASSIFICATION_LEVEL_FIELD = 'topic-hub-classification-level-field';
export const TOPIC_HUB_SCHEDULE_MODAL = 'topic-hub-schedule-modal';
export const TOPIC_HUB_COMMENTS_FILTER = 'topic-hub-comments-filter';
export const TOPIC_HUB_ROW_CHECKBOX = 'topic-hub-row-checkbox';
export const TOPIC_HUB_BULK_ACTIONS = 'topic-hub-bulk-actions';
export const TOPIC_HUB_ROW_ACTIONS_MENU = 'topic-hub-row-actions-menu';
export const TOPIC_HUB_DISCUSSION_GROUP_SELECT = 'topic-hub-discussion-group-select';
export const TOPIC_HUB_SUBMITTED_BY_GROUP_SELECT = 'topic-hub-submitted-by-group-select';
export const CLONE_TOPIC_DISCUSSION_GROUP_SELECT = 'clone-topic-discussion-group-select';
export const CLONE_TOPIC_SUBMITTED_BY_GROUP_SELECT = 'clone-topic-submitted-by-group-select';

// topic hub details

export const TOPIC_HUB_DETAILS_AGENDA_ITEM_TITLE_CLEAR =
    'topic-hub-details-agenda-item-title-clear-button';
export const TOPIC_HUB_DETAILS_TOPIC_NAME_CLEAR = 'topic-hub-details-topic-name-clear-button';
export const TOPIC_HUB_DETAILS_AGENDA_ITEM_LEADER_CLEAR =
    'topic-hub-details-item-leader-clear-button';
export const TOPIC_HUB_DETAILS_REQUESTER_USER_ROW = 'topic-hub-details-requester-user-row';

// library
export const LIBRARY_LABELS_FILTER = 'library-labels-filter';
export const LIBRARY_DRAG_DROP = 'drag-and-drop';
export const LIBRARY_CREATE_NEW_LABEL = 'library-create-new-label';
export const LIBRARY_SELECT_ALL_CHECKBOX = 'library-select-all-checkbox';
export const LIBRARY_SEND_EMAIL_LIST = 'library-send-email-list';
export const LIBRARY_FILTERS = 'library-filters';
export const LIBRARY_ROW_MORE_ACTIONS_MENU_OPTIONS = 'library-row-more-actions-menu-options';
export const LIBRARY_SECURITY_ICON = 'security-icon-level';
export const DOCUMENT_FAVORITE_REMOVE = 'document-favorite-remove';
export const DOCUMENT_MARK_AS_UNREAD = 'document-mark-as-unread';
export const LIBRARY_ADD_DOCUMENT_BUTTON = 'add-document-button';
export const LIBRARY_ADD_FOLDER_BUTTON = 'add-folder-button';
export const LIBRARY_NEW_BUTTON = 'library-new-button';
export const LIBRARY_MOVE_MODAL = 'library-move-modal';
export const DOCUMENTS_LIST_BULK_BAR = 'documents-list-bulk-bar';

// meetingOverview
export const MEETING_LIST_TIMEFRAME_SELECT = 'timeframe-select';
export const MEETING_LIST_ROW = 'meeting-list-row';
export const MEETING_LIST_ROW_NAME = 'meeting-list-row-name';
export const MEETING_LIST_ROW_LOCK_ICON = 'meeting-list-row-lock-icon';
export const MEETINGS_LIST_SEPARATOR = 'meetings-list-separator-header';
export const MEETINGS_LIST_SECTION_HEADER = 'meetings-list-section-header';
export const EDITOR_MEETING_LEADER_TOGGLE = 'editor-meeting-leader-toggle';
export const MEETINGS_ADD = 'add-new-meeting';
export const MEETINGS_SELECT_PHYSICAL = 'physical-meeting';
export const MEETINGS_SELECT_DCR = 'circular-resolution-meeting';
export const OPEN_VISIBILITY_MODAL_BUTTON = 'open-visibility-modal-button';
export const SELECTABLE_PARTICIPANT_ROW = 'selectable-participant-row';
export const SELECTABLE_GROUP_ROW = 'selectable-group-row';
export const SUMMARY_PARTICIPANT_ROW = 'summary-participant-row';
export const NEXT_MEETING_LIST_ROW = 'next-meeting-list-row';
export const NEW_MEETING_BUTTON = 'new-meeting-button';
export const NEXT_MEETING_BUTTON = 'next-meeting-button';
export const NEXT_MEETING_PILL = 'next-meeting-pill';
export const ONGOING_MEETING_PILL = 'ongoing-meeting-pill';
export const MEETING_OVERVIEW_FILTERS = 'meeting-overview-filters';
export const MEETING_OVERVIEW_GROUPS_FILTER = 'meeting-overview-groups-filter';
export const MEETING_OVERVIEW_PUBLISHING_STATUS_FILTER =
    'meeting-overview-publishing-status-filter';
export const MEETING_OVERVIEW_PARTICIPANTS_FILTER = 'meeting-overview-participants-filter';
export const MEETING_ALLOCATE_SECTION_MENU_TRIGGER = 'meeting-allocate-section-menu-trigger';

// meetingOverview participant view
export const APPROVE_AGENDA = 'approve-agenda';
export const APPROVE_MINUTES = 'approve-minutes';
export const APPROVAL_STATUS = 'approvals-status';
export const OPEN_APPROVAL_MODAL_BUTTON = 'open-approval-modal-button';
export const OPEN_AGENDA_APPROVAL = 'open-agenda-approval';
export const OPEN_MINUTES_APPROVAL = 'open-minutes-approval';
export const PARTICIPANT_ROW = 'participant-row';
export const NEXT_MEETING_CARD = 'next-meeting-card';
export const MEETING_OVERVIEW_FILTER_ITEM = 'meeting-overview-filter-item';
export const MEETING_PREPAREDNESS = 'meeting-preparedness';
export const TODAY_PLACEMENT = 'today-placement';
export const MEETING_FEEDBACK_CUSTOM = 'meeting-feedback-custom';
export const MEETING_TIME = 'meeting-time';
export const PARTIAL_MEETING_TIME = 'partial-meeting-time';
export const UPLOAD_DOCUMENTS_BUTTON = 'upload-documents-button';
export const UPLOAD_CONTRIBUTION_REQUEST_BUTTON = 'upload-contribution-request-button';
export const REMOVE_UN_UPLOADED_CONTRIBUTION_REQUEST = 'remove-un-uploaded-contribution-request';
export const DOCUMENT_FILTER_ITEM_NAME = 'document-filter-item-name';
export const TODOS_LIST = 'todos-list';
export const PREPAREDNESS_LOADING_SKELETON = 'preparedness-loading-skeleton';
export const EMPTY_TODOS_EMPTY_MEETINGS = 'empty-todos-empty-meetings';
export const EMPTY_TODOS_WITH_MEETINGS = 'empty-todos-with-meetings';
export const NOTE_ANNOTATION_TEXTAREA = 'note-annotation-textarea';
export const AGENDA_ITEM_COLLAPSABLE_ITEM = 'agenda-item-collapsable-item';
export const AGENDA_ITEM_VISIBLE_SECTION = 'agenda-item-visible-section';

// document upload
export const FOLDER_ROW = 'folder-row';
export const DOCUMENT_ROW = 'document-row';
export const DOCUMENT_UPLOAD_CANCEL = 'document-upload-cancel';
export const DOCUMENT_UPLOAD_ADD = 'document-upload-add';
export const DOCUMENT_UPLOAD_TAB_UPLOAD = 'tab-upload';
export const DOCUMENT_UPLOAD_TAB_UNALLOCATED = 'tab-unallocated';
export const DOCUMENT_UPLOAD_LIST = 'upload-documents-list';
export const DOCUMENT_UPLOAD_DROPZONE = 'upload-document-dropzone';
export const DOCUMENT_UPLOAD_DROPZONE_BUTTON = 'upload-document-dropzone-button';
export const DOCUMENT_UPLOAD_DROPZONE_HINT = 'upload-document-dropzone-hint';
export const DOCUMENT_REMOVE_FROM_LIST = 'document-remove';
export const DOCUMENT_UPLOAD_STATUS_CHECKMARK = 'upload-status-check-mark';
export const PROGRESS_BAR_DESCRIPTION = 'progress-bar-description';
export const UPLOAD_DOCUMENT_ICON = 'upload-document-icon';
export const UPLOAD_DOCUMENT_NAME = 'upload-document-name';
export const UPLOADED_DOCUMENT_ROW = 'uploaded-document-row';

// UI elements
export const SELECT_WITH_EDIT_OPTION = 'select-with-edit-option';
export const EDITOR_DIFF_ADDED_TEXT = 'editor-diff-added-text';
export const EDITOR_DIFF_REMOVED_TEXT = 'editor-diff-removed-text';
export const EDITOR_DIFF_UNCHANGED_TEXT = 'editor-diff-unchanged-text';

// global search
export const SEARCH_RESULT_ROW_TITLE = (type: SearchResultType, title: string) =>
    `search-result-${type}: ${title}`;
export const GLOBAL_SEARCH_BUTTON = 'global-search-button';
export const GLOBAL_SEARCH_FILTERS = 'global-search-filters';
export const GLOBAL_SEARCH_FILTERS_CHIPS = 'global-search-filters-chips';
export const GLOBAL_SEARCH_ROOM_FILTER = 'global-search-room-filter';
export const GLOBAL_SEARCH_GROUP_FILTER = 'global-search-group-filter';
export const GLOBAL_SEARCH_LABEL_FILTER = 'global-search-label-filter';
export const GLOBAL_SEARCH_RESULT_ITEM = 'global-search-result-item';
export const GLOBAL_SEARCH_OPEN_NEW_TAB = 'global-search-open-new-tab';
export const GLOBAL_SEARCH_STATUS_FILTER = 'global-search-status-filter';
export const GLOBAL_SEARCH_MINUTES_TYPE_FILTER = 'global-search-minutes-type-filter';
export const GLOBAL_SEARCH_RESULTS = 'global-search-results';

// form control
export const FORM_CONTROL_CLEAR_BUTTON = 'form-control-clear-button';

// send email notification
export const EMAIL_SUBJECT = 'email-subject';
export const EMAIL_MESSAGE = 'email-message';

// access overview
export const SHOW_DOCUMENTS_TOGGLE = 'show-documents-toggle';
export const ACCESS_OVERVIEW_ITEM_NUMBER = 'access-overview-item-number';
export const ACCESS_OVERVIEW_ACCESS_INDICATOR = 'access-overview-access-indicator';
export const ACCESS_OVERVIEW_ORGANISATIONAL_ITEM_NUMBER =
    'access-overview-organisational-item-number';
export const ACCESS_OVERVIEW_MEMBER_LIST = 'access-overview-member-list';

// forms
export const FILTER_NAME_FIELD = 'filter-name-field';
export const FILTER_STATE_SELECTOR = 'filter-state-selector';
export const NEW_FORM_BUTTON = 'new-form-button';
export const FORM_NAME_FIELD = 'form-name-field';
export const FORM_RESPONDENTS_FIELD = 'form-respondents-field';
export const NEW_FORM_NEXT_BUTTON = 'new-form-next-button';
export const NEW_FORM_CREATE_BUTTON = 'new-form-create-button';
export const FORM_RESPONDENTS_BUTTON = 'form-respondents-button';
export const DOWNLOAD_FORM_XLSX_BUTTON = 'download-form-xlsx-button';
export const COPY_FORM_LINK_BUTTON = 'copy-form-link-button';
export const DELETE_FORM_BUTTON = 'delete-form-button';
export const EVALUATION_FIELD_CONTAINER = 'evaluation-field-container';
export const EVALUATION_FIELD = 'evaluation-field';
export const READ_ONLY_EVALUATION_FIELD = 'readonly-evaluation-field';
export const FORM_LIST_ROW = 'form-list-row';
export const SEND_FORM = 'send-form';
export const QUESTION_ANSWERED = 'question-answered';
export const QUESTION_UNANSWERED = 'question-unanswered';
export const LEAVE_FORM_BUTTON = 'leave-form-button';
export const FORM_FILTER_OPTION = 'form-filter-option';
export const FORM_FILTERS = 'form-filters';

// room settings
export const OPEN_ROOM_SETTINGS_BUTTON = 'open-room-settings-button';
export const SAVE_ROOM_SETTINGS_BUTTON = 'save-room-settings-button';
export const CANCEL_ROOM_SETTINGS_BUTTON = 'cancel-room-settings-button';
export const MEETING_FEEDBACK_SETTING_TOGGLE = 'meeting-feedback-setting-toggle';
export const AGENDA_ITEM_DURATION_ROOM_SETTING_SELECTOR =
    'agenda-item-duration-room-setting-selector';
export const DOCUMENT_SECURITY_BUTTON = 'document-security-button';
export const SHARING_PREPAREDNESS_LEVEL_BUTTON = 'sharing-preparedness-level-button';
export const CUSTOM_INVITATION_BUTTON = 'custom-invitation-button';
export const MEETING_FEEDBACK_FORM_BUTTON = 'meeting-feedback-form-button';
export const CONFERENCE_CALL_BUTTON = 'conference-call-button';
export const AGENDA_ITEM_DURATION_BUTTON = 'agenda-item-duration-button';
export const COVER_PAGE_TOGGLE = 'cover-page-toggle';
export const AGENDA_PAGE_TOGGLE = 'agenda-page-toggle';

// custom invitation settings
export const CUSTOM_INVITATION_SETTINGS_BUTTON = 'custom-invitation-settings-button';
export const CUSTOM_INVITATION_FULLSCREEN_BUTTON = 'custom-invitation-fullscreen-button';

// home module
export const VIEW_IN_MEETING_LIST = 'view-in-meeting-list';
export const UPCOMING_MEETINGS_INFO = 'upcoming-meetings-info';
export const TODO_LIST_HIDE_PAST_MEETINGS = 'todo-list-hide-past-meetings';
export const TODO_LIST_ROW = 'todo-list-row';
export const TODO_GROUP_DISMISS_BUTTON = 'todo-group-dismiss-button';

export const RICH_EDITOR_FILE_UPLOAD_INPUT = 'rich-editor-file-upload-input';
export const FILTERS_BUTTON = 'filter-toggle-button';
